export default {
  getterListInvoice: state => state.listInvoice,
  getterInvoice: state => state.invoice,
}
